<template>
  <div class="change-password old-globals">
    <change-password-form />
  </div>
</template>

<script>
import ChangePasswordForm from "../../components/account/ChangePasswordForm";

export default {
  name: "change-password",
  components: {
    ChangePasswordForm,
  },
  data: () => ({
    state: {
    }
  }),
  methods: {
  },
};
</script>

<style scoped>
</style>
